export default __webpack_public_path__ + "static/The Home_Image 4_carousel 3@2x-c8430ce8e500c22d7fd1a1ae057759c0.jpg";